import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const fetchAccountDetails = createAsyncThunk('account/fetchAccountDetails', async () => {
  // const user = await usersApi.fetchUserDetails();
  // if (!user) {
  //   return {
  //     error: {
  //       type: 'error',
  //       message: 'Something went wrong',
  //     },
  //   }
  // }
  return {
    details: '',
  };
});

const accountsSlice = createSlice({
  name: 'account',
  initialState: {
    status: 'idle',
    error: {
      type: '',
      message: '',
    },
    details: {},
  },
  reducers: {
    setAccount: (state, action) => {
      state.details = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchAccountDetails.fulfilled, (state, action) => {
      state.status = 'ok';
      state.details = action.payload.details;
    });
    builder.addCase(fetchAccountDetails.rejected, (state) => {
      state.status = 'error';
      state.error.message = 'Something went wrong';
    });
    builder.addCase(fetchAccountDetails.pending, (state) => {
      state.status = 'loading';
    });
  },
});

export const { setAccount } = accountsSlice.actions;
export default accountsSlice.reducer;
